import React from 'react';

import TradeStores from '../../../../components/TradeStores';

function renderTradeStoresBlock(data, index) {

  return (
    <section
      className={'trade_stores_section'}
      key={index}
      style={{ backgroundColor: data.BACKGROUND_COLOR }}
    >
      <TradeStores {...data} />
    </section>
  );
}

export default renderTradeStoresBlock;